import { Check, X } from 'lucide-react'

interface PasswordStrengthIndicatorProps {
  password: string
  confirmPassword?: string
}

const rules = [
  { test: (p: string) => p.length >= 8, label: 'Mínimo 8 caracteres' },
  { test: (p: string) => /[A-Z]/.test(p), label: 'Letra maiúscula' },
  { test: (p: string) => /[a-z]/.test(p), label: 'Letra minúscula' },
  { test: (p: string) => /[0-9]/.test(p), label: 'Número' },
  { test: (p: string) => /[@$!%*?&#]/.test(p), label: 'Caractere especial (@$!%*?&#)' },
]

export function isPasswordStrong(password: string): boolean {
  return rules.every((rule) => rule.test(password))
}

export default function PasswordStrengthIndicator({
  password,
  confirmPassword,
}: PasswordStrengthIndicatorProps) {
  if (!password) return null

  return (
    <div className="space-y-1.5 text-sm">
      {rules.map((rule) => {
        const passed = rule.test(password)
        return (
          <div key={rule.label} className="flex items-center gap-2">
            {passed ? (
              <Check className="w-3.5 h-3.5 text-green-500 shrink-0" />
            ) : (
              <X className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
            )}
            <span
              className={passed ? 'text-green-600 dark:text-green-400' : 'text-muted-foreground'}
            >
              {rule.label}
            </span>
          </div>
        )
      })}
      {confirmPassword !== undefined && confirmPassword.length > 0 && (
        <div className="flex items-center gap-2">
          {password === confirmPassword ? (
            <Check className="w-3.5 h-3.5 text-green-500 shrink-0" />
          ) : (
            <X className="w-3.5 h-3.5 text-destructive shrink-0" />
          )}
          <span
            className={
              password === confirmPassword
                ? 'text-green-600 dark:text-green-400'
                : 'text-destructive'
            }
          >
            Senhas coincidem
          </span>
        </div>
      )}
    </div>
  )
}
